const $targets = $('.scroll-in');   // 対象

  function inViewport($el, offset = 0) {
    const winTop = $(window).scrollTop();
    const winBottom = winTop + $(window).height();
    const elTop = $el.offset().top;
    const elBottom = elTop + $el.outerHeight();
    // 上下どちらかが可視領域に入れば true（offset で手前トリガーも可）
    return elBottom > (winTop + offset) && elTop < (winBottom - offset);
  }

  function check() {
    // まだ .show が付いてない要素だけを見る（無駄な判定を減らす）
    $('.scroll-in').not('.show').each(function () {
      const $el = $(this);
      if (inViewport($el, 50)) { // 50px 手前でトリガーしたい場合はここを調整
        $el.addClass('show');
      }
    });
  }

  // スクロール・リサイズで判定
  $(window).on('scroll resize', check);

  // 初回ロード時にも判定
  check();